import { useQuery } from 'react-query'

import { USER_TOKEN_KEY } from '@auth/auth.localstorage'
import { getCurrentProfessional } from '@professionals/professionals.services'
import { LoggedUser, UseCurrentProfessional } from '@professionals/professionals.types'
import { useLocalStorage } from '@services/local-storage.hooks'

export const useCurrentProfessional: UseCurrentProfessional = (options = {}) => {
  const { storedValue: token } = useLocalStorage<string | undefined>(USER_TOKEN_KEY, undefined)

  const queryKey = ['current-professional', token]
  const queryFunc = getCurrentProfessional
  const queryOptions = { enabled: token != null, ...options }

  const { data } = useQuery<LoggedUser>(queryKey, queryFunc, queryOptions)

  return data || undefined
}
